const STORAGE_UNSAFE_FILE_NAME_CHARACTERS = /[^a-zA-Z0-9.-]/g

export function storedAttachmentFileName(fileName: string): string {
  return fileName.replace(STORAGE_UNSAFE_FILE_NAME_CHARACTERS, "_")
}

export function isSameStoredAttachmentFileName(firstFileName: string, secondFileName: string): boolean {
  return storedAttachmentFileName(firstFileName) === storedAttachmentFileName(secondFileName)
}
